import { Button, Result } from 'antd'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export function NotFoundPage() {
  const { t } = useTranslation()

  return (
    <Result
      status="404"
      title="404"
      subTitle={t('notFound.text')}
      extra={
        <Link to="/">
          <Button type="primary">{t('access.backToStart')}</Button>
        </Link>
      }
    />
  )
}
